module.exports = __webpack_public_path__ + "assets/img/LTC033.efb57ac7.png";